var _path, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Training",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.598,
    height: 78.21,
    viewBox: "0 0 81.598 78.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M418.065,122.305a5.072,5.072,0,0,1,1.411.209l8.447-10.354a1.555,1.555,0,0,1,2.195-.226,1.514,1.514,0,0,1,.192,2.125L421.958,124.3a4.783,4.783,0,0,1-1.925,7.167H452.8a2.178,2.178,0,0,0,2.177-2.177V101.727A2.178,2.178,0,0,0,452.8,99.55H411.177A2.178,2.178,0,0,0,409,101.727v18.1l1.968,2.491h7.1Z",
    transform: "translate(-373.382 -92.575)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 8.917,
    cy: 8.917,
    r: 8.917,
    transform: "translate(8.613)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15049",
    "data-name": "Group 15049",
    transform: "translate(0 20.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M26.674,312.392a2.178,2.178,0,0,1-2.177,2.177H20.839a2.178,2.178,0,0,1-2.177-2.177V294.139a1.167,1.167,0,0,0-1.167-1.167h0a1.167,1.167,0,0,0-1.167,1.167v18.166a2.271,2.271,0,0,1-2.264,2.264H10.485a2.178,2.178,0,0,1-2.177-2.177L8.29,268.327a1.08,1.08,0,0,0-1.08-1.08h0a1.08,1.08,0,0,0-1.08,1.08v16.947a2.178,2.178,0,0,1-2.177,2.177H2.177A2.178,2.178,0,0,1,0,285.274V262.04a4.989,4.989,0,0,1,4.99-4.99H24.819a6.986,6.986,0,0,1,5.46,2.639l5.329,6.723,1.123,1.419s5.051,0,7.96.009a2.178,2.178,0,0,1,2.177,2.177v1.733a2.178,2.178,0,0,1-2.177,2.177H35.269a3.033,3.033,0,0,1-2.386-1.158l-3.971-5.1a1.085,1.085,0,0,0-.853-.418h-.27a1.08,1.08,0,0,0-1.08,1.08Z",
    transform: "translate(0 -257.05)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training_icon.c44c6f5aa4efda89d8e18a0797c3aacc.svg";
export { ForwardRef as ReactComponent };